import React, { useState, useEffect } from 'react';
import {
  Card,
  CardBody,
  Form,
  FormGroup,
  FormText,
  FormFeedback,
  Label,
  Table,
  Input,
  Button,
  Row,
  Col,
  Spinner,
  Tooltip,
  Breadcrumb,
  BreadcrumbItem
} from 'reactstrap';
import Select from 'react-select';
import Skeleton from 'react-loading-skeleton';
import { ApiService } from '../../../constants';
import { HttpService } from '../../../utilities';
import Swal from 'sweetalert2';
import { DateTime } from '../../../components/datetime';
import { useMutation, useQuery } from '@tanstack/react-query';
import {
  approve,
  detailEvaluation,
  getListFacilitator,
  getMasterQuestionEvaluation,
  postEvaluation,
  reject,
  updateEvaluation
} from '../../../services/selfreport-evaluation';
import { showNotification } from '../../../utilities/mantineNotification';
import FacilitatorModal from '../../event/event/FacilitatorModal';
import AdminLayout from '../../../components/layout/admin';
import PageHeaderWrapper from '../../../components/page_header_wrapper';
import HelmetTitle from '../../../components/helmet_title/HelmetTitle';
import { useDisclosure } from '@mantine/hooks';
import { Flex, Modal } from '@mantine/core';
import moment from 'moment';
import SearchInput from '../../../components/elements/SearchInput';
import TablePagination from '../../../components/table_pagination';
import Paging from '../../../components/pagination';

const EditEvaluationSharingSession = (props) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any>({});

  const [selfReportAsOptions, setSelfReportAsOptions] = useState<any>([]);
  const [selfReportAsSelected, setSelfReportAsSelected] = useState<any>();
  const [programTypeOptions, setProgramTypeOptions] = useState<any>([]);
  const [programTypeSelected, setProgramTypeSelected] = useState<any>(null);
  const [showModalFacilitator, setShowModalFacilitator] =
    useState<boolean>(false);

  const handleFacilitatorData = (rows) => {
    let newObj = { ...data };
    if (newObj.facilitators && newObj.facilitators.length > 0) {
      for (const ix in rows) {
        let found = false;
        if (!rows[ix]['keyId'] || rows[ix]['keyId'] == '') {
          rows[ix]['keyId'] =
            (rows[ix].id || '') + '-' + (rows[ix].facilitatorId || '');
        }
        for (const ij in newObj.facilitators) {
          if (newObj.facilitators[ij].keyId == rows[ix].keyId) {
            found = true;
            newObj.facilitators[ij] = rows[ix];
            break;
          }
        }
        if (!found) {
          newObj.facilitators.push(rows[ix]);
        }
      }
    } else {
      newObj.facilitators = rows;
    }
    setData(newObj);
  };

  // ========>>>>>> START SELF REPORT ENHANCEMENT <<<<<==========
  const [dataResponse, setDataResponse] = useState<any>([]);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [sessionTitle, setSessionTitle] = useState('');
  const [sessionStart, setSessionStart] = useState('');
  const [sessionEnd, setSessionEnd] = useState('');
  const [learningDelivery, setLearningDelivery] = useState(null);
  const [feedbackContent, setFeedbackContent] = useState('');
  const [feedbackFacilitator, setFeedbackFacilitator] = useState('');
  const [feedbackFacility, setFeedbackFacility] = useState('');
  const [duration, setDuration] = useState('');
  const [facilitatorSelected, setFacilitatorSelected] = useState(null);
  const [notes, setNotes] = useState('');

  const [userRoleOptions, setUserRoleOptions] = useState<any>([
    { value: '999', label: 'Sharing Session' }
  ]);
  const [userRoleSelected, setUserRoleSelected] =
    useState<any>('Sharing Session');
  const [reportAs, setReportAs] = useState('Participant');

  const [listLearningMethod, setListLearningMethod] = useState([
    { value: '001', label: 'Face to Face' },
    { value: '002', label: 'Online' },
    { value: '003', label: 'Blended' }
  ]);
  const [facilitatorList, setFacilitatorList] = useState([]);
  const [status, setStatus] = useState('');
  const [selectedQuestionEvaluation, setSelectedQuestionEvaluation] = useState(
    []
  );
  const [filteredQuestionEvaluation, setFilteredQuestionEvaluation] = useState(
    []
  );

  const [selected, setSelected] = useState([]);
  const [search, setSearch] = useState('');
  const [mode, setMode] = useState('list');
  const [facilitatorName, setFacilitatorName] = useState('');
  const [facilitatorInstitution, setFacilitatorInstitution] = useState('');
  const [facilitatorEmail, setFacilitatorEmail] = useState('');
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [takePage, setTakePage] = useState(10);
  const [pageOption, setPageOption] = useState([10, 25, 50, 100]);

  useEffect(() => {
    if (learningDelivery) {
      if (learningDelivery.value === '001') {
        const faceToFace = selectedQuestionEvaluation.filter(
          (item) => item.type === 'facetoface'
        );
        setFilteredQuestionEvaluation(faceToFace);
      } else if (learningDelivery.value === '002') {
        const online = selectedQuestionEvaluation.filter(
          (item) => item.type === 'online'
        );
        setFilteredQuestionEvaluation(online);
      } else {
        const blended = selectedQuestionEvaluation.filter(
          (item) => item.type === 'blended'
        );
        setFilteredQuestionEvaluation(blended);
      }
    }
  }, [learningDelivery]);

  const fetchedMasterQuestion = useQuery({
    queryKey: [`masterQuestion`],
    queryFn: () => getMasterQuestionEvaluation(),
    enabled: true
  });

  const [listFacilitator, setListFacilitator] = useState([]);
  const [filteredFacilitator, setFilteredFacilitator] = useState([]);

  const fetchedListFacilitator = useQuery({
    queryKey: [`list-fasil-eval-form`],
    queryFn: () => getListFacilitator(),
    enabled: true,
    onSuccess: (response) => {
      if (response?.data?.resultCode === 200) {
        const data = response?.data?.data;
        // try to add isSelected to each facilitator
        data.map((it) => {
          it.isSelected = false;
        });
        setListFacilitator(data);
        setFilteredFacilitator(data);
      }
    }
  });

  const getUserData: any = () => {
    const jsonString = localStorage.getItem('persist:root');
    const object = JSON.parse(jsonString);
    return JSON.parse(object.auth).userData;
  };

  const _userData = getUserData();

  useEffect(() => {
    if (props.match.params.id === null) {
      props.history.push('/home');
    }
    if (selfReportAsSelected) {
      if (selfReportAsSelected.value === '001') {
        const _userData = getUserData();
        // if (_userData && !_userData.isTeacher) {
        if (!userRoleOptions.find((it) => it.value === '999')) {
          setUserRoleOptions([
            ...userRoleOptions,
            { value: '999', label: 'Sharing Session' }
          ]);
        }
        // }
      }
    }
    const payload = {
      id: props.match.params.id
    };
    detailData.mutate(payload);
  }, [selfReportAsSelected]);

  const detailData = useMutation({
    mutationFn: detailEvaluation,
    onSuccess: (response) => {
      if (response?.data?.resultCode === 200) {
        const data = response?.data?.data;
        setDataResponse(data);
        setSessionTitle(data.trainingName);
        setSessionStart(data.sessionStart);
        setSessionEnd(data.sessionEnd);
        setDuration(data.duration);
        setNotes(data.notes);
        setFeedbackContent(data.feedbackContent);
        setFeedbackFacilitator(data.feedbackFacilitator);
        setFeedbackFacility(data.feedbackFacility);
        setFacilitatorList(data.facilitators);
        setStatus(data.status);
        const updatedFetchedMasterQuestion =
          fetchedMasterQuestion?.data?.data?.data?.map((masterQuestion) => {
            const evaluation = data?.evaluation?.find(
              (evalItem) =>
                evalItem.type === masterQuestion.type &&
                evalItem.question === masterQuestion.question &&
                evalItem.translate === masterQuestion.translate
            );

            if (evaluation) {
              return {
                ...masterQuestion,
                answer: evaluation.answer // Update answer jika evaluationFormID sama
              };
            }

            return masterQuestion;
          });
        setSelectedQuestionEvaluation(updatedFetchedMasterQuestion);

        if (data.evaluation[0].type === 'online') {
          setLearningDelivery({ value: '002', label: 'Online' });
        } else if (data.evaluation[0].type === 'facetoface') {
          setLearningDelivery({ value: '001', label: 'Face to Face' });
        } else {
          setLearningDelivery({ value: '003', label: 'Blended' });
        }
      } else {
        showNotification({
          type: 'error',
          title: 'Oh no! something wrong when saved your interest',
          message:
            response?.data?.errorMessage ||
            'Failed when save interest. Please try again'
        });
      }
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: JSON.stringify(error)
      });
    }
  });

  const submitEvaluation = (e) => {
    const _userData = getUserData();
    e.preventDefault();
    Swal.fire({
      title: 'Question!',
      text: 'Do you want to submit this data?',
      showCancelButton: true,
      confirmButtonText: 'Yes'
    }).then((result) => {
      if (result.isConfirmed) {
        // try to filter the evaluation with the type

        const payload = {
          evaluationFormID: props.match.params.id,
          selfReportSelected: {
            value: '001',
            label: 'Participant'
          },
          userRoleSelected: {
            value: '999',
            label: 'Sharing Session'
          },
          binusianId: _userData.binusianId,
          evaluation: filteredQuestionEvaluation,
          sessionTitle: sessionTitle,
          sessionStart: sessionStart,
          sessionEnd: sessionEnd,
          facilitators: facilitatorList,
          learningDelivery: learningDelivery,
          feedbackContent: feedbackContent,
          feedbackFacilitator: feedbackFacilitator,
          feedbackFacility: feedbackFacility,
          duration: duration,
          status: '001'
        };
        // console.log(payload);
        saveEval.mutate(payload);
      }
    });
  };

  const saveEval = useMutation({
    mutationFn: updateEvaluation,
    onSuccess: (response) => {
      if (response?.data?.resultCode === 200) {
        showNotification({
          type: 'success',
          title: 'Yeay! we`re saved your interest',
          message: 'We`ll give you best recommendation for you'
        });
        close();
        window.location.href = '/dashboard/main';
      } else {
        showNotification({
          type: 'error',
          title: 'Oh no! something wrong when saved your interest',
          message:
            response?.data?.errorMessage ||
            'Failed when save interest. Please try again'
        });
      }
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: JSON.stringify(error)
      });
    }
  });

  // ========>>>>>> END SELF REPORT ENHANCEMENT <<<<<==========

  const handleShowFacilitatorModal = (e) => {
    e.preventDefault();
    setShowModalFacilitator(!showModalFacilitator);
  };

  const handleDeleteFacilitator = (e, index) => {
    e.preventDefault();
    // try to remove the facilitator by index
    const _facilitatorList = facilitatorList.filter((it, idx) => idx !== index);
    setFacilitatorList(_facilitatorList);
  };

  const [opened, { open, close }] = useDisclosure(false);

  const renderRequestorInformation = () => {
    return (
      <>
        <hr className="my-4" />
        <h5 className="font-weight-bold">Requestor Information</h5>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label>Binusian ID</Label>
              <Input
                name="binusianId"
                value={dataResponse.binusianId || ''}
                placeholder="Binusian ID"
                disabled={true}
                type="text"
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>Name</Label>
              <Input
                name="fullName"
                value={dataResponse.fullName || ''}
                placeholder="Fullname"
                disabled={true}
                type="text"
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>Division / BU</Label>
              <Input
                name="division"
                value={
                  dataResponse.businessUnitName ||
                  dataResponse.divisionName ||
                  ''
                }
                placeholder="Division"
                disabled={true}
                type="text"
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>Department / Major</Label>
              <Input
                name="department"
                value={dataResponse.department || ''}
                placeholder="Department"
                disabled={true}
                type="text"
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>Position</Label>
              <Input
                name="position"
                value={dataResponse.position || ''}
                placeholder="Position"
                disabled={true}
                type="text"
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label>Email</Label>
              <Input
                name="Email"
                value={dataResponse.email || ''}
                placeholder="Email"
                disabled={true}
                type="text"
              />
            </FormGroup>
          </Col>
        </Row>
        <hr className="my-4" />
      </>
    );
  };

  const handleSearchFacilitator = (e) => {
    e.preventDefault();
    setPage(1);
    const _search = search.toLowerCase();
    const _filtered = listFacilitator.filter((it) => {
      return (
        it.facilitatorName.toLowerCase().includes(_search) ||
        it.facilitatorInstitution.toLowerCase().includes(_search) ||
        it.facilitatorEmail.toLowerCase().includes(_search)
      );
    });

    const _nocheckFiltered = _filtered.filter((it) => {
      return !facilitatorList.find(
        (fl) => fl.facilitatorEmail === it.facilitatorEmail
      );
    });
    setFilteredFacilitator(_nocheckFiltered);
  };

  const renderTablePaging = (dataFacil, _selected) => {
    const tableComuns = [
      {
        title: 'Facilitator Name',
        name: 'facilitatorName',
        itemAlign: 'left'
      },
      {
        title: 'Facilitator Institution',
        name: 'facilitatorInstitution',
        itemAlign: 'left'
      },
      {
        title: 'Facilitator Email',
        name: 'facilitatorEmail',
        itemAlign: 'left'
      },
      {
        title: 'Select',
        name: '',
        itemAlign: 'center',
        // width: '12%',
        disableSorting: true
      }
    ];

    const handleCheckboxChange = (email) => {
      // set the selected facilitator by email
      const _selected = filteredFacilitator.map((it) => {
        if (it.facilitatorEmail === email) {
          it.isSelected = !it.isSelected;
        }
        return it;
      });
      setSelected(_selected);
    };

    const tableRowMapper = (row, index) => {
      return [
        <span key={`name-${index}`}>{row.facilitatorName}</span>,
        <span key={`institution-${index}`}>{row.facilitatorInstitution}</span>,
        <span key={`email-${index}`}>{row.facilitatorEmail}</span>,
        <span key={`checkbox-${index}`}>
          <Input
            onClick={() => handleCheckboxChange(row.facilitatorEmail)}
            checked={row.isSelected}
            type="checkbox"
          />
        </span>
      ];
    };

    const renderFacilitatorAdd = () => {
      return (
        <>
          {/* <FacilitatorModal
            selectedfacilitators={facilitatorList}
            showModal={showModalFacilitator}
            handleData={handleFacilitatorData}
            toggleModal={handleShowFacilitatorModal}
          /> */}
          <Table striped>
            <thead>
              <tr>
                <th>Facilitator Name</th>
                <th>Facilitator Institution</th>
                <th>Facilitator Email</th>
                <th>Select</th>
              </tr>
            </thead>
            <tbody>
              {dataFacil
                // get the pagination data
                .slice((page - 1) * takePage, page * takePage)
                .map((row, index) => (
                  <tr key={index}>
                    {tableRowMapper(row, index).map((cell, cellIndex) => (
                      <td key={cellIndex}>{cell}</td>
                    ))}
                  </tr>
                ))}
            </tbody>
          </Table>
        </>
      );
    };

    const handleChangePage = (newPage) => {
      setPage(newPage);
    };

    const handleChangePerPage = (newPerPage) => {
      setTakePage(newPerPage);
    };

    return (
      <>
        {renderFacilitatorAdd()}
        <Paging
          total={dataFacil.length}
          take={takePage}
          page={page}
          pageOption={pageOption}
          onPageChange={handleChangePage}
          onPerPageChange={handleChangePerPage}
        />
        {/* <TablePagination
          data={dataFacil}
          tableRowMapper={tableRowMapper}
          perPage={10}
          tableComuns={tableComuns}
        /> */}
      </>
    );
  };

  const handleSubmitAddFacil = (e) => {
    e.preventDefault();
    const newObj = {
      facilitatorName: facilitatorName,
      facilitatorInstitution: facilitatorInstitution,
      facilitatorEmail: facilitatorEmail,
      keyId: facilitatorName + facilitatorEmail
    };
    setFacilitatorList([...facilitatorList, newObj]);
    setSearch('');
    setMode('list');
    close();
  };

  const handleAddFacilByCheck = (e) => {
    e.preventDefault();
    const correctKeys = [
      'facilitatorEmail',
      'facilitatorInstitution',
      'facilitatorName',
      'keyId'
    ];

    // get the selected facilitator
    const selectedFacilitator = filteredFacilitator.filter(
      (it) => it.isSelected
    );

    const correctedFacilitator = selectedFacilitator.map((it) => {
      const newObj = {};
      for (const key in it) {
        if (correctKeys.includes(key)) {
          newObj[key] = it[key];
        }
      }
      return newObj;
    });
    // then add the facilitator to the list
    setFacilitatorList([...facilitatorList, ...correctedFacilitator]);
    setFilteredFacilitator(listFacilitator);
    setSearch('');
    setMode('list');
    close();
  };

  const renderFacilitator = () => {
    return (
      <>
        {/* <FacilitatorModal
          selectedfacilitators={facilitatorList}
          showModal={showModalFacilitator}
          handleData={handleFacilitatorData}
          toggleModal={handleShowFacilitatorModal}
        /> */}
        <h5 className="font-weight-bold required">Facilitators</h5>

        <Table striped>
          <thead>
            <tr>
              <th>Facilitator Name</th>
              <th>Facilitator Institution</th>
              <th>Facilitator Email</th>
              <th className="action-col">Action</th>
            </tr>
          </thead>
          <tbody>
            {facilitatorList &&
              facilitatorList?.map((row, i) => {
                return (
                  <tr key={i}>
                    <td>{row.facilitatorName}</td>
                    <td>{row.facilitatorInstitution}</td>
                    <td>{row.facilitatorEmail}</td>
                    <td width="10%">
                      {facilitatorList.length > 0 && (
                        <a
                          href="#"
                          onClick={(e) => handleDeleteFacilitator(e, i)}
                          className="mr-2"
                        >
                          <i className="fa fa-trash"></i>
                        </a>
                      )}
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </Table>
        <Modal
          opened={opened}
          onClose={close}
          title="Add Facilitator"
          size={'xl'}
        >
          {mode === 'list' ? (
            <>
              <Flex>
                <div
                  style={{
                    flex: 1
                  }}
                >
                  <Input
                    bsSize="lg"
                    placeholder="Search Facilitator"
                    value={search}
                    onKeyDown={(
                      event: React.KeyboardEvent<HTMLDivElement>
                    ): void => {
                      if (event.key === 'Enter') {
                        event.preventDefault();
                        event.stopPropagation();
                        handleSearchFacilitator(event);
                      }
                    }}
                    onChange={(e) => setSearch(e.target.value)}
                    type="text"
                  />
                </div>
                <Button
                  type="button"
                  color="warning"
                  size="lg"
                  onClick={handleSearchFacilitator}
                  className="ml-2"
                >
                  Search
                </Button>
                <Button
                  type="button"
                  color="warning"
                  size="lg"
                  className="ml-2"
                  onClick={() => {
                    setSearch('');
                    setPage(1);
                    const _filtered = listFacilitator.filter((it) => {
                      return !facilitatorList.find(
                        (fl) => fl.facilitatorEmail === it.facilitatorEmail
                      );
                    });
                    setFilteredFacilitator(_filtered);
                  }}
                >
                  Reset
                </Button>
              </Flex>
              <div
                style={{
                  marginTop: '20px'
                }}
              >
                {renderTablePaging(filteredFacilitator, selected)}
              </div>
              <div className="text-center">
                <i>if you can't find your facilitator please click here.</i>
                <Button
                  style={{ width: 200, margin: '0 auto' }}
                  color="warning"
                  block
                  size="lg"
                  onClick={() => {
                    setMode('form');
                  }}
                  type="button"
                >
                  Add New Facilitator
                </Button>
              </div>
              <Row className="mt-5 justify-content-md-center">
                <Col md={2}>
                  <Button
                    color="success"
                    block
                    size="lg"
                    type="button"
                    onClick={close}
                  >
                    Cancel
                  </Button>
                </Col>
                <Col md={2}>
                  <Button
                    color="warning"
                    block
                    size="lg"
                    onClick={handleAddFacilByCheck}
                    type="button"
                  >
                    Save
                  </Button>
                </Col>
              </Row>
            </>
          ) : (
            <div>
              <form onSubmit={handleSubmitAddFacil}>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label className="required">
                        Facilitator Name <b style={{ color: 'red' }}>*</b>
                      </Label>
                      <Input
                        name="facilitatorName"
                        value={facilitatorName}
                        required
                        onChange={(e) => {
                          setFacilitatorName(e.target.value);
                        }}
                        placeholder="Facilitator Name"
                        type="text"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label className="required">
                        Facilitator Institution{' '}
                        <b style={{ color: 'red' }}>*</b>
                      </Label>
                      <Input
                        name="facilitatorInstitution"
                        value={facilitatorInstitution}
                        placeholder="Facilitator Institution"
                        required
                        onChange={(e) => {
                          setFacilitatorInstitution(e.target.value);
                        }}
                        type="text"
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>Facilitator Email</Label>
                      <Input
                        name="facilitatorEmail"
                        value={facilitatorEmail}
                        placeholder="Facilitator Email"
                        onChange={(e) => {
                          setFacilitatorEmail(e.target.value);
                        }}
                        type="text"
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row className="mt-5 justify-content-md-center">
                  <Col md={2}>
                    <Button
                      color="success"
                      block
                      size="lg"
                      type="button"
                      onClick={(e) => {
                        setMode('list');
                      }}
                    >
                      Cancel
                    </Button>
                  </Col>
                  <Col md={2}>
                    <Button
                      color="warning"
                      block
                      size="lg"
                      onClick={() => {}}
                      type="submit"
                    >
                      Save
                    </Button>
                  </Col>
                </Row>
              </form>
            </div>
          )}
        </Modal>
        {/* <Button
          type="button"
          color="warning"
          size="lg"
          className="mb-4"
          onClick={
            handleShowFacilitatorModal
          }
        >
          Add Facilitator
        </Button> */}
        <Button
          type="button"
          color="warning"
          size="lg"
          className="mb-4"
          onClick={() => {
            const _filtered = filteredFacilitator.filter((it) => {
              return !facilitatorList.find(
                (fl) => fl.facilitatorEmail === it.facilitatorEmail
              );
            });
            setFilteredFacilitator(_filtered);

            open();
          }}
        >
          Add Facilitator
        </Button>
      </>
    );
  };

  return (
    <AdminLayout>
      <PageHeaderWrapper>
        <HelmetTitle title="Edit Self Report" />
        <Breadcrumb>
          <BreadcrumbItem active>Edit Self Report</BreadcrumbItem>
        </Breadcrumb>
      </PageHeaderWrapper>
      <Card>
        <CardBody>
          {/* <h4 className="status-name">Status : { data.statusName || '-' }</h4> */}
          {!loading ? (
            <Form>
              <form>
                <FormGroup>
                  <Label className="required">Self Report As</Label>
                  <Input
                    value={reportAs || ''}
                    placeholder=""
                    required
                    type="text"
                    disabled={true}
                  />
                </FormGroup>
                <FormGroup>
                  <Label className="required">Program Type</Label>
                  <Input
                    value={userRoleSelected || ''}
                    required
                    type="text"
                    disabled={true}
                  />
                </FormGroup>
                {renderRequestorInformation()}
                {/* <hr className="my-4" /> */}
                <h5 className="font-weight-bold">Training Information</h5>
                <FormGroup>
                  <Label className="required">Session Title</Label>
                  <Input
                    name="sessionTitle"
                    value={sessionTitle || ''}
                    placeholder="Session Title"
                    onChange={(e) => setSessionTitle(e.target.value)}
                    required
                    type="text"
                    // disabled={true}
                  />
                </FormGroup>
                <Row>
                  <Col md={4}>
                    <FormGroup>
                      <Label className="required">Session Start Date</Label>
                      <DateTime
                        value={sessionStart || ''}
                        onChange={(e) => {
                          setSessionStart(e);
                        }}
                      />
                      {/* <Input
                        name="trainingStartTime"
                        value={formatDate(sessionStart)}
                        placeholder="Start Date & Time"
                        type="text"
                        disabled={true}
                      /> */}
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Label className="required">Session End Date</Label>
                      <DateTime
                        value={sessionEnd || ''}
                        onChange={(e) => {
                          setSessionEnd(e);
                        }}
                      />
                      {/* <Input
                        name="trainingEndTime"
                        value={formatDate(sessionEnd)}
                        placeholder="End Date & Time"
                        type="text"
                        disabled={true}
                      /> */}
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Label className="required">Duration</Label>

                      <Input
                        name="duration"
                        value={duration}
                        placeholder="Duration"
                        onChange={(e) => setDuration(e.target.value)}
                        type="text"
                      />
                    </FormGroup>
                  </Col>
                </Row>

                {renderFacilitator()}
                <FormGroup>
                  <Label className="required">Learning Delivery Method</Label>
                  <Select
                    name="learningDeliveryMethod"
                    value={learningDelivery || ''}
                    onChange={(e) => setLearningDelivery(e)}
                    options={listLearningMethod}
                  />
                </FormGroup>
                {learningDelivery && (
                  <>
                    <hr className="my-4" />
                    <h5 className="font-weight-bold">
                      {learningDelivery.value == '003'
                        ? 'Blended Training Evaluation'
                        : learningDelivery.value === '002'
                        ? 'Online Training Evaluation'
                        : 'Face to Face Training Evaluation'}
                    </h5>
                    <div
                      style={{
                        marginBottom: '20px'
                      }}
                    >
                      <p>
                        Kami menghargai evaluasi Anda terhadap pelatihan ini dan
                        mohon bantuan Anda untuk melengkapi form ini. Dalam
                        skala 1-6, mohon mengisi nomor yang sesuai dengan
                        pendapat Anda terhadap setiap pertanyaan.
                      </p>
                      <i
                        style={{
                          color: 'gray'
                        }}
                      >
                        We value your evaluation regarding this training and
                        would need your help to complete the form. On a scale of
                        1-6, please fill in the number that indicates your
                        opinion on each statement.
                      </i>
                    </div>
                    {Array.isArray(filteredQuestionEvaluation) &&
                      filteredQuestionEvaluation.map((item, index) => (
                        <FormGroup key={index}>
                          <div
                            style={{
                              display: 'flex',
                              marginBottom: '10px'
                            }}
                          >
                            <div
                              style={{
                                marginRight: '10px'
                              }}
                            >
                              <Label>{index + 1}.</Label>
                            </div>
                            <div
                              style={{
                                display: 'table-column'
                              }}
                            >
                              <div>
                                <Label>{item.translate}</Label>
                              </div>
                              <div>
                                <i
                                  style={{
                                    color: 'gray'
                                  }}
                                >
                                  {item.question}
                                </i>
                              </div>
                            </div>
                          </div>
                          <Row form>
                            {Array.from({ length: 6 }, (_, i) => i + 1).map(
                              (value) => (
                                <Col md={2} key={value}>
                                  <FormGroup check>
                                    <Label check>
                                      <Input
                                        type="radio"
                                        name={`question-${index}`}
                                        value={value}
                                        checked={item.answer === value}
                                        onChange={() => {
                                          setFilteredQuestionEvaluation(
                                            (currentEvaluation) =>
                                              currentEvaluation.map(
                                                (evalItem, evalIndex) =>
                                                  evalIndex === index
                                                    ? {
                                                        ...evalItem,
                                                        answer: value
                                                      }
                                                    : evalItem
                                              )
                                          );
                                        }}
                                      />
                                      {value === 1
                                        ? 'Strongly Disagree'
                                        : value === 2
                                        ? 'Disagree'
                                        : value === 3
                                        ? 'Slighly Disagree'
                                        : value === 4
                                        ? 'Slighly Agree'
                                        : value === 5
                                        ? 'Agree'
                                        : 'Strongly Agree'}
                                    </Label>
                                  </FormGroup>
                                </Col>
                              )
                            )}
                          </Row>
                        </FormGroup>
                      ))}
                  </>
                )}
                <hr className="my-4" />
                <FormGroup>
                  <Label>Feedback Content</Label>
                  <Input
                    name="isiContent"
                    value={feedbackContent || ''}
                    placeholder="Feedback Content"
                    onChange={(e) => {
                      setFeedbackContent(e.target.value);
                    }}
                    rows="4"
                    type="textarea"
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Feedback Facilitator</Label>
                  <Input
                    name="isiFacilitator"
                    value={feedbackFacilitator || ''}
                    placeholder="Feedback Facilitator"
                    onChange={(e) => {
                      setFeedbackFacilitator(e.target.value);
                    }}
                    rows="4"
                    type="textarea"
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Feedback Facility</Label>
                  <Input
                    name="isiFacility"
                    value={feedbackFacility || ''}
                    placeholder="Feedback Facility"
                    onChange={(e) => {
                      setFeedbackFacility(e.target.value);
                    }}
                    rows="4"
                    type="textarea"
                  />
                </FormGroup>
                {notes !== '' ? (
                  <FormGroup>
                    <Label>BCL&D Notes</Label>
                    <Input
                      required
                      name="notes"
                      disabled={true}
                      value={notes || ''}
                      placeholder="Notes"
                      rows="4"
                      type="textarea"
                    />
                  </FormGroup>
                ) : null}
                {status === '001' ? null : (
                  <Label style={{ fontWeight: 'bold', color: '#7B2183' }}>
                    {status === '002' ? 'Approved' : 'Rejected'} by{' '}
                    {dataResponse?.approvedBy}{' '}
                    {moment(dataResponse?.approvedAt).format(
                      'DD MMM YYYY HH:mm'
                    )}
                  </Label>
                )}
                {/* <b>Approved by Arief Arfiansyah 03 Jul 2024 19:31</b> */}

                <Row className="mt-5 justify-content-md-center">
                  <Col md={2}>
                    <Button
                      color="warning"
                      block
                      // disabled={loadingSubmit}
                      size="lg"
                      onClick={submitEvaluation}
                      type="submit"
                    >
                      {loadingSubmit ? (
                        <Spinner size="sm" />
                      ) : (
                        <span>Submit</span>
                      )}
                    </Button>
                  </Col>
                </Row>
              </form>
            </Form>
          ) : (
            <Skeleton count={4} />
          )}
        </CardBody>
      </Card>
    </AdminLayout>
  );
};

function formatDate(date: string | number | Date): string {
  if (!date) {
    return '';
  }
  const d = new Date(date);
  if (isNaN(d.getTime())) {
    return '';
  }
  // Format the date components
  const day = d.getDate().toString().padStart(2, '0');
  const month = (d.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-based
  const year = d.getFullYear();
  const hours = d.getHours().toString().padStart(2, '0');
  const minutes = d.getMinutes().toString().padStart(2, '0');

  // Construct the formatted date string in "DD/MM/YYYY hh:mm" format
  return `${day}/${month}/${year} ${hours}:${minutes}`;
}

export default EditEvaluationSharingSession;
